import React from 'react';
import SoterTaskComparisonsListContainer from './ComparisonContainer/ComparisonsListContainer';
import PrivatePageHOC from '../../containers/PrivatPageHOC/PrivatePageHOC';

const SoterTaskComparison = () => <SoterTaskComparisonsListContainer />;

export default PrivatePageHOC(SoterTaskComparison);
